// import axiosModule from "axios";
// // Create an Axios instance
// export const axios = axiosModule.create({
//   baseURL: "https://your-api-url.com", // Replace with your API base URL
// });

// // Add a request interceptor to include token in headers
// axios.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });
import axiosModule from "axios";

// Create an Axios instance
export const axios = axiosModule.create({
  baseURL: "https://your-api-url.com", // Replace with your API base URL
});

// Function to refresh the token
async function refreshAuthToken() {
  // console.log("Refreshing token");
  // try {
  //   const response = await axiosModule.get(
  //     process.env.REACT_APP_BACKEND + "auth/regenrateToken"
  //   );
  //   console.log(response);
  //   const newToken = response.data.token;
  //   // const newRefreshToken = response.data.refreshToken; // If the API provides a new refresh token
  //   localStorage.setItem("token", newToken);
  //   // localStorage.setItem("refreshToken", newRefreshToken); // Update refresh token if provided
  //   return newToken;
  // } catch (error) {
  // console.error("Error refreshing token", error);
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  window.location.href = "/login"; // Redirect to login
  return null;
  // }
}

// Add a request interceptor to include token in headers
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle token expiration and regeneration
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      return null;
    }

    return Promise.reject(error);
  }
);
